/* eslint-disable react-hooks/exhaustive-deps */
import {useLayoutEffect, useState} from "react";
import {CustomElementStatus} from "./CustomElementStatus";

export function useCustomElementStatus(
  element: string | string[]
): CustomElementStatus {
  const [status, setStatus] = useState<CustomElementStatus>(
    CustomElementStatus.UNDEFINED
  );
  const names = Array.isArray(element) ? element : [element];
  useLayoutEffect(() => {
    // prettier-ignore
    Promise.all(names.map(name => window.customElements.whenDefined(name)))
            .then(() => setStatus(CustomElementStatus.DEFINED));
  }, [...names]);
  return status;
}
